import type { ConfirmationDialogProps } from './ConfirmationDialog';

type ConfirmationPreset = Pick<
  ConfirmationDialogProps,
  'title' | 'text' | 'cancelText' | 'confirmText' | 'destructive'
>;

export const dashboardConfirmationPresets = {
  removeWidget: {
    title: 'Remove app?',
    text: 'This app will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove',
    destructive: true
  },
  discard: {
    title: 'Discard changes?',
    text: 'Unsaved changes will be lost',
    cancelText: 'Keep editing',
    confirmText: 'Discard changes',
    destructive: true
  },
  removeItem: {
    title: 'Remove item?',
    text: 'This item will be removed from selected items',
    cancelText: 'Cancel',
    confirmText: 'Remove',
    destructive: true
  },
  removeAll: {
    title: 'Remove all?',
    text: 'All apps will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove',
    destructive: true
  },
  removeDashboard: {
    title: 'Delete dashboard?',
    text: 'This dashboard will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Delete',
    destructive: true
  },
  removeTab: {
    title: 'Remove tab?',
    text: 'This tab will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove',
    destructive: true
  },
  removeDashboardItem: {
    title: 'Remove item?',
    text: 'This item will be removed from your dashboard',
    cancelText: 'Cancel',
    confirmText: 'Remove',
    destructive: true
  }
} satisfies Record<string, ConfirmationPreset>;
